angular.module('swapick')
.controller('HomeCtrl', HomeCtrl);


function HomeCtrl($scope, DataService, DataStrategies, $ionicLoading,
  ionPullUpFooterState, $timeout, $ionicScrollDelegate, Districts,
  Filters, Categories, initialLoaderManager, $q, $stateParams) {


  this.categories = null;
  this.districts = [];
  this.filters = { mondo:null, categoria:null, district:null};
  this.footerState = ionPullUpFooterState.EXPANDED;

  DataStrategies.createPagerMethods(
    this,
    $scope,
    {
      method: DataService.base.all('api/items'),
      callMethodName : 'getList',
      pageSize : 33, hasSearch:true,
      params : () => ({
        cat_id : this.filters.categoria,
        world_id : this.filters.mondo,
        district_id : this.filters.district ? this.filters.district.id : null,
        user_id : $stateParams.userId,
        q : this.searchString
      })
    }
  );


  this.loader = initialLoaderManager.makeLoader(() => {
    return Districts
    .getDistricts()
    .then(districts => {
      this.districts = districts;
      return Categories.getCategories()
    })
    .then(categories => {
      this.filters = {
        mondo: Filters.getFilter('home.mondo'),
        categoria: Filters.getFilter('home.categoria'),
        district: Filters.getFilter('home.district'),
        //search : null
      };
      this.categoriesData = Categories.data;
      return this.loadPage();
    });

  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.objects.length){
        this.loader.load();
      }
  });

  $scope.$on('$ionicView.afterEnter', () => {
    $ionicScrollDelegate.resize();
  });


  this.updateFromFilters = () => {
    if(!this.filters.mondo){
      this.filters.categoria = null;
    }

    const currentFilters = {
      mondo : Filters.getFilter('home.mondo'),
      categoria : Filters.getFilter('home.categoria'),
      district : Filters.getFilter('home.district'),
    }

    if(currentFilters.mondo != this.filters.mondo || currentFilters.categoria != this.filters.categoria || (currentFilters.district != (this.filters.district ? this.filters.district.id :null))){
      this.objects = [];
      $ionicScrollDelegate.scrollTop();
      this.loadMore();
    }

    Filters.setFilter('home.mondo', this.filters.mondo);
    Filters.setFilter('home.categoria', this.filters.categoria);
    Filters.setFilter('home.district', this.filters.district);
  }



  this.getCategoriesForFilter = () => {
    if(!this.filters.mondo){
      return this.categories;
    }
    return this.categoriesData.categoriesByMondo[this.filters.mondo]
  }

  this.closeFilters = () =>{
    $timeout(()=>{
      this.footerState = ionPullUpFooterState.COLLAPSED;
    });
  };

  this.clearFilters = () => {
    $timeout(()=>{
      this.filters.mondo = null;
      this.filters.categoria = null;
      this.filters.district = null;
      this.footerState = ionPullUpFooterState.COLLAPSED;
      this.updateFromFilters();
    });
  };

  this.hasFilters = () => {
    return this.filters.mondo || this.filters.categoria || this.filters.district;
  };

  this.filtersDisplay = () => {
    if(this.hasFilters()){
      let mondo = this.filters.mondo ? `${this.categoriesData.mondiById[this.filters.mondo][0]['nome']}` : '';
      let cat = this.filters.categoria ? `: ${this.categoriesData.categoriesById[this.filters.categoria][0].nome}` : '';
      let prov = this.filters.district ? ` (${this.filters.district.automobile})` : '';
      return `${mondo}${cat}${prov}`;
    }
    return '<i class="icon ion-funnel"></i> Filtra la lista';
  };

}



// WEBPACK FOOTER //
// ./src/controllers/home-controller.js